<template>
  <div
    class="yxtbiz-ai-robot__dialog"
    :class="{ 'fullscreen-dialog': bFullscreen }"
  >
 
    <!-- 对话框头部 -->
    <div class="yxtbiz-ai-robot__dialog--header">
      <div class="yxtbiz-ai-robot__dialog--header-left">
        <yxtf-portrait
          v-if="!bFullscreen && settings.assistHeadImg"
          class="mr12 hand"
          size="small"
          username="AI"
          :imgUrl="settings.assistHeadImg"
          @click="showChatList"
        />
        <span v-if="!bFullscreen">{{ title }}</span>
      </div>
      <div v-if="!hideHeadToolbar" class="yxtbiz-ai-robot__dialog--header-right">
        <header-icon
          class="mr16"
          :size="iconSize"
          @click="share"
          icon-name="share"
          :pop-text="$t('pc_biz_ai_share').d('分享')"
          remote
        />
        <template v-if="!max">
          <header-icon
            class="mr16"
            remote
            :size="iconSize"
            :icon-name="bFullscreen ? 'ai-window' : 'ai-screen'"
            :pop-text="
              bFullscreen
                ? $t('pc_biz_ai_small_window').d('小窗口')
                : $t('pc_biz_ai_full_screen').d('全屏')
            "
            @click="changeFullSize"
          />
          <header-icon
            class="mr16"
            remote
            :size="iconSize"
            icon-name="ai-closed"
            :pop-text="$t('pc_biz_ai_close').d('关闭')"
            @click="handleClose"
          />
        </template>
      </div>
    </div>

    <div class="yxtbiz-flex-1 yxtbiz-flex-column h0">
      <yxtf-scrollbar :viewClass="bFullscreen ? 'mw720' : ''" wrapClass="overflow-y-hidden" :fit-height="true">
        <!-- 对话框主体 -->
        <div class="yxtbiz-ai-robot__dialog--body" :style="aiBodyStyle">
            <yxtf-scrollbar
              class="yxtbiz-ai-robot-scrollbar"
              ref="scrollbar"
              :fit-height="true">
              <infinite-scroll v-if="!noMoreHistory" @more="getHistory"></infinite-scroll>
              <div :class="{'ml24 mr24':bFullscreen}">
                <ul ref="dialogBody" class="is-msg-list">
                  <li
                    v-for="(msg, index) in msgList"
                    :key="index"
                    class="width-percent-100"
                    :class="{ 'yxtbiz-ai-robot__dialog--msg-question': msg.chatType === 0, 'pl40': bFullscreen && msg.chatType === 0 }"
                  >
                    <Message
                      :msg="msg"
                      :lastMsg="index === msgList.length - 1"
                      :isWaitAnswer="isWaitAnswer"
                      :fullscreen="bFullscreen"
                      @resend="val => resend(msg, val, index)"
                      @scrollToEnd="scrollToEnd"
                      @submit="handleSubmitMessage"
                    ></Message>
                  </li>
                </ul>
              </div>
            </yxtf-scrollbar>
          </div>
          <!-- 底部输入框 -->
          <div class="yxtbiz-ai-robot__dialog--footer">
            <input-magic
              v-if="settings.hasShortcutInstruction === 1"
              @change="handleChangeMagic"
              ref="inputMagicRef"
            />
            <div :class="{
                'textarea-content': true,
                'textarea-focus': focus,
                'more-lines': inputHeight > 52 || (magicTag && magicTag.appName)
              }">
              <span
                class="stop-answer"
                :class="{ 'stop-instruction-answer': settings.hasShortcutInstruction === 1 }"
                v-if="isWaitAnswer"
                @click="stopAIAnswer()"
              >
                <span class="block"></span>
                <span> {{ $t('pc_biz_lbl_stop_reply').d('停止回答') }}</span>
              </span>
              <div class="yxtbiz-ai-robot__wrap">
                <div
                  v-if="magicTag"
                  class="yxtbiz-ai-robot__wrap--tag"
                >
                  <yxt-tag
                    closable
                    @close="magicTag = null"
                  >{{ magicTag.appName || '' }}</yxt-tag>
                </div>
                <textarea
                  :class="{ 'no-question': !isSendShow,'font-size-14': !bFullscreen}"
                  class="no-shortcut-textarea"
                  ref="textarea"
                  v-model="question"
                  maxlength="2000"
                  :placeholder="getInputHolder"
                  @keydown="keydown"
                  @input="handleInputQuestion"
                  @focus="focus = true"
                  @blur="focus = false"
                ></textarea>
                <yxt-tooltip
                  v-if="isSendShow"
                  :content="$t('pc_biz_ai_send_wait').d('暂时不能发送，请稍后再试！')"
                  placement="top"
                  :disabled="!isWaitAnswer"
                >
                  <div
                    :class="{ 'ai-robot-btn-send': true, 'disbale-send': isWaitAnswer }"
                    @click="isWaitAnswer ? null : sendMsg()"
                  >
                    <img :src="sendSvg" />
                  </div>
                </yxt-tooltip>
              </div>
            </div>
          </div>
      </yxtf-scrollbar>
    </div>

    

    <!-- 弹窗 -->
    <Share v-if="showShare" />
    <FeedbackDialog ref="feedback"/>
  </div>
</template>

<script>
import {MSG_TYPE, CHAT_TYPE, ASK_TYPE, ANSWER_STATUS} from '../const';
import {
  submitQuestion,
  questionHistory,
  getAskReqId,
  stopQuestion,
  getStaticBaseUrl,
  postInspection,
  submitQuestionLike
} from '../service';
import Message from './message.vue';
import HeaderIcon from './headerIcon.vue';
import InfiniteScroll from './infiniteScroll.vue';
import Share from './share.vue';
import InputMagic from './inputMagic.vue';
import FeedbackDialog from './feedbackDialog.vue';
import { timestampToTime, CommonAskIdHandler } from '../utils';

export default {
  name: 'MsgDialog',
  components: {
    InfiniteScroll,
    Message,
    HeaderIcon,
    Share,
    InputMagic,
    FeedbackDialog
  },
  props: {
    max: { // 单独页面，非dialog
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default() {
        return this.$t('pc_biz_ai_title').d('企业AI助手');
      }
    },
    bFullscreen: {
      type: Boolean,
      default: false
    },
    clientType: {
      type: Number,
      default: 0 // 0-学员端，1-管理端
    },
    waitAnswer: Boolean,
    hideHeadToolbar: Boolean
  },
  provide() {
    return {
      getIsWaitAnswer: () => this.isWaitAnswer
    };
  },
  inject: ['settings'],
  data() {
    return {
      sendSvg: `${getStaticBaseUrl()}ufd/407a24/assistent/pc/svg/send.svg`,
      stopAnswerList: {}, // 待停止的回答队列ID集合
      isfirstLoad: true,
      maxCreateTime: '',
      excludeIds: [],
      resendMsg: null,
      showShare: false,
      isWaitAnswer: false,
      inputHeight: 52, // 输入框高度
      question: '',
      askQuestion: '',
      msgList: [],
      askHistory: [],
      screenId: '',
      focus: false,
      currentFeedbackIndex: 0,
      magicTag: null, // 显示的魔法标签
      noMoreHistory: true, // 无更多历史消息
      commonAskIdHandler: null,
      showLargeTreasure: false,
      askType: ASK_TYPE.KNOWLEDGE,
      feedbackDialogVisible: false
    };
  },
  computed: {
    getInputHolder() {
      if (this.magicTag && this.magicTag.guide) {
        return this.magicTag.guide;
      }

      return this.$t(this.settings.hasShortcutInstruction === 1
        ? 'pc_biz_lbl_ai_holder_order' : this.settings.hasShortcutInstruction === 0
          ? 'pc_biz_ai_input_problem' : ''
      );
    },
    aiBodyStyle() {
      if (this.magicTag) {
        return { height: 'calc( 100vh - ' + (this.inputHeight + 12 + 92 + 38 + 29) + 'px )' };
      } else {
        return { height: 'calc( 100vh - ' + (this.inputHeight + 12 + 92 + (this.settings.hasShortcutInstruction === 1 ? 32 : 0)) + 'px )' };
      }
    },
    iconSize() {
      return this.bFullscreen ? 24 : 20;
    },
    closeIconSize() {
      const size = this.bFullscreen ? 26 : 22;
      return `${size}px`;
    },
    isSendShow() {
      const q = this.question.trim();
      return q && q !== '/';
    }
  },
  watch: {
    question: function(v) {
      this.resizeTextarea(v);
    },
    isWaitAnswer: function(val) {
      this.$emit('update:waitAnswer', val);
    }
  },
  methods: {
    changeUpdateAI(screenId, isNew) {
      if (!this.commonAskIdHandler) this.commonAskIdHandler = new CommonAskIdHandler();
      this.$refs.inputMagicRef && (this.$refs.inputMagicRef.selected = ASK_TYPE.KNOWLEDGE);
      if (!isNew) {
        Object.assign(this.$data, {...this.$options.data.call(this), commonAskIdHandler: this.commonAskIdHandler});
        this.screenId = screenId;
        if (!this.screenId) {
          // 新窗口 默认提示语
          this.msgList = [this.getWelcomeMsg(true)];
          this.askType = ASK_TYPE.KNOWLEDGE;
        } else {
          this.noMoreHistory = false;
        }
      } else {
        this.screenId = screenId;
      }
    },
    handleClose() {
      this.commonAskIdHandler.destoryReleaseAsset();
      this.commonAskIdHandler = null;
      this.$emit('close');
    },
    getWelcomeMsg(isInit, askType = ASK_TYPE.KNOWLEDGE) {
      const knowledgeWelcome = this.settings.hasShortcutInstruction ? this.$t('pc_biz_ass_lbl_welcome') : this.$t('pc_biz_ass_lbl_welcomesingle');
      const instructWelcome = this.$t('pc_biz_ass_lbl_instructwelcom');
      const defaultWelcome = this.settings.assistWele || this.$t('pc_biz_ai_question_default_tips');
      const content = isInit ? defaultWelcome : (askType === ASK_TYPE.KNOWLEDGE ? knowledgeWelcome : instructWelcome);
      const subContent = isInit ? knowledgeWelcome : '';
      const item = {
        type: MSG_TYPE.WELCOME,
        chatType: CHAT_TYPE.ANSWER,
        askType,
        contentDetail: {
          content,
          subContent
        }
      };
      return item;
    },
    initDialogData(isInit, content, subContent, askType = ASK_TYPE.KNOWLEDGE) {
      const item = {
        type: MSG_TYPE.WELCOME,
        chatType: CHAT_TYPE.ANSWER,
        askType,
        contentDetail: {
          content,
          subContent
        }
      };
      if (isInit) {
        this.msgList = [item];
      } else {
        this.msgList.push(item);
      }
      this.$nextTick(this.scrollToEnd);
    },
    // 小窗口点击头像
    showChatList() {
      this.$emit('showChatList');
    },
    handleSubmitMessage(data) {
      this.question = data.question || '';
      this.sendMsg(null, {
        askType: ASK_TYPE.INSTRUCT,
        bizAppId: data.bizAppId,
        askId: data.askId,
        bizParam: data.bizParam,
        needIntent: 0
      });
    },
    handleChangeMagic(v) {
      this.askTypeChange(v.categoryCode === 'kng' ? 0 : 1);
      if (v.showType === 'treasure') {
        this.question = v.guide || '';
      } else if (this.question === '/') {
        this.question = '';
      }
      this.magicTag = v;
    },
    handleShareVisible() {
      this.showShare = false;
    },
    handleInputQuestion(e) {
      if (this.settings.hasShortcutInstruction !== 1) return;

      const value = e.target.value.trim();
      if (value && value.length === 1 && value[0] === '/') {
        // 匹配指令
        this.$refs.inputMagicRef && this.$refs.inputMagicRef.show();
      }
    },
    async stopAIAnswer() {
      this.submitRequest.abort && this.submitRequest.abort();
      // 获取队列中最新条的key
      let lastKey = Object.keys(this.stopAnswerList)[
        Object.keys(this.stopAnswerList).length - 1
      ];
      this.stopAnswerList[lastKey] = true;
      this.isWaitAnswer = false;
      let { answerStatus, contentDetail } = this.msgList[
        this.msgList.length - 1
      ]; // 数组最后一项
      await stopQuestion({
        askReqId: lastKey,
        stopText: (contentDetail && contentDetail.content) || '已停止回答',
        stopOtherText: (contentDetail && contentDetail.otherSourceAnswer) || ''
      });
      if (answerStatus === ANSWER_STATUS.PENDING) {
        let stopMessage = {
          chatType: CHAT_TYPE.ANSWER,
          type: MSG_TYPE.STOP,
          contentDetail: {
            content: this.$t('pc_biz_ai_stoped_answer').d('已停止回答'), // 拼接消息体
            linkList: []
          }
        };
        // 如果在回答中
        this.msgList.pop();
        this.msgList.push(stopMessage);
        this.resendMsg = null;
      }
      this.scrollToEnd();
    },
    // 自适应输入框调整
    resizeTextarea(v) {
      const textarea = this.$refs.textarea;
      this.inputHeight = 52;
      textarea.style.height = 52 + 'px';
      if (v) {
        this.$nextTick(()=>{
          if (textarea.scrollHeight > 52) {
            this.inputHeight = Math.min(textarea.scrollHeight, 165);
            textarea.style.height = this.inputHeight + 'px';
          }
        });
      }
    },
    // 获取历史消息
    getHistory() {
      const dialogBody = this.$refs.dialogBody;
      const offsetH = dialogBody.offsetHeight;
      !this.count ? (this.count = 1) : this.count++;
      this.msgList.unshift({
        // 添加加加载历史等待效果
        answerStatus: ANSWER_STATUS.PENDING,
        chatType: CHAT_TYPE.ANSWER
      });
      questionHistory({
        excludeIds: this.excludeIds,
        askSessionId: this.commonAskIdHandler.getAskId(),
        sessionId: this.commonAskIdHandler.getAskId(),
        maxCreateTime: this.maxCreateTime,
        chatSessionId: this.screenId,
        clientType: this.clientType
      }).then(async res => {
        this.msgList.shift(); // 清除首位置添加的等待效果
        if (res && res.list && res.list.length) {
          // 格式化消息记录消息体
          let chatLog = res.list;
          chatLog.reverse(); // 聊天记录顺序反转一次
          this.msgList.unshift(...chatLog.map(chat => ({ ...chat, isHistory: true }))); // 拼接历史消息记录
          this.$nextTick(() => {
            // 滑动效果
            this.scrollTo(dialogBody.offsetHeight - offsetH);
          });
          if (res.excludeIds && res.excludeIds.length) {
            // 如果还有更多历史消息
            this.excludeIds = res.excludeIds;
            this.maxCreateTime = res.maxCreateTime;
          }
          if (this.msgList.length < 10) {
            // 消息总条数少于10条
            this.noMoreHistory = true;
          }
        } else {
          this.noMoreHistory = true;
          if (this.msgList.length > 5) {
            this.msgList.unshift({
              chatType: CHAT_TYPE.OTHER,
              type: MSG_TYPE.END,
              content: this.$t('pc_biz_ai_no_more').d('暂无更多')
            });
          }
        }
        if (this.count === 1) {
          this.msgList.push(this.getWelcomeMsg(true));
        }
        if (this.isfirstLoad) {
          this.getQueryAskHistory();
        }
        this.isfirstLoad = false;
      });
    },
    keydown(e) {
      if (e.shiftKey || e.altKey) return;
      if (e.keyCode === 13) {
        e.preventDefault();
        if (e.ctrlKey) {
          this.question += '\n';
        } else {
          this.sendMsg();
        }
      }
    },
    onPrompt(val, bizAppId = '', needIntent) {
      // 初始化的试着问一问
      if (this.isWaitAnswer) {
        // 等待中
        this.$message.warning(this.$t('pc_biz_ai_send_wait').d('暂时不能发送，请稍后再试！'));
        return;
      }
      this.question = val;
      this.sendMsg(null, {
        askType: bizAppId ? 1 : 0,
        bizAppId,
        needIntent
      });
    },
    // 重新发送
    resend(msg, resendType, index) {
      for (let i = index; i >= 0; i--) {
        // 往前找提问消息 找到第一个终止
        if (this.msgList[i] && this.msgList[i].chatType === 0) {
          this.resendMsg = {
            contentDetail: {
              content:
                this.msgList[i].contentDetail &&
                this.msgList[i].contentDetail.content
            },
            chatType: 0
          };
          if (msg.askInternet) {
            this.sendMsg('askInternet', {needIntent: 0});
          } else {
            this.sendMsg(resendType, {
              askType: msg.bizAppId ? 1 : 0,
              bizAppId: msg.bizAppId
            });
          }
          break;
        }
      }
    },
    askInternet(msg) {
      const index = this.msgList.findIndex(item => item.askId === msg.askId);
      for (let i = index; i >= 0; i--) {
        // 往前找提问消息 找到第一个终止
        if (this.msgList[i] && this.msgList[i].chatType === 0) {
          this.resendMsg = {
            contentDetail: {
              content:
                this.msgList[i].contentDetail &&
                this.msgList[i].contentDetail.content
            },
            chatType: 0,
            snowId: msg.askReqId
          };
          this.sendMsg('askInternet', {
            askId: msg.askId,
            needIntent: 0
          });
          break;
        }
      }
    },
    async sendMsg(resendType, { askType, bizAppId, bizParam, askId, needIntent = 1 } = {}) {
      let self = this;
      // 答案等待中，不可发消息
      if (this.isWaitAnswer) {
        return this.$message.warning(this.$t('pc_biz_ai_send_wait').d('暂时不能发送，请稍后再试！'));
      }
      // 输入框为空，不可发消息
      let str = this.question.replace(/(^\s*)|(\s*$)/g, '');
      if (!str && !this.resendMsg) {
        this.$message.warning(this.$t('pc_biz_ai_input_not_empty').d('发送内容不能为空！'));
        this.question = '';
        return;
      }
      // 敏感词检验
      if (resendType !== 'askInternet') {
        const inspectionData = await postInspection((this.resendMsg && this.resendMsg.contentDetail.content) || str);
        if (inspectionData && inspectionData.sourceContent !== inspectionData.targetContent) {
          return this.$message.warning(this.$t('pc_biz_msg_inspection_reinput'/** 您输入的内容含有企业敏感词，请重新输入 */));
        }
      }

      this.$emit('getChatSetting'); // 每次发送消息都重新拿一下配置
      let { snowId } = resendType === 'askInternet' ? this.resendMsg : await getAskReqId();
      if (this.isWaitAnswer) return;
      this.stopAnswerList[snowId] = false;
      if (resendType !== 'askInternet') {
        this.addQuestion();
        this.addAnswer();
      }
      this.isWaitAnswer = true;
      const at = resendType === 'askInternet' ? ASK_TYPE.INTERNET : this.askType;
      this.submitRequest = submitQuestion(
        {
          askContent: (this.resendMsg && this.resendMsg.contentDetail.content) || this.askQuestion,
          askHistory: this.askHistory, // 带上最近的三条记录
          askSessionId: this.commonAskIdHandler.getAskId(),
          sessionId: this.commonAskIdHandler.getAskId(),
          askReqId: snowId,
          askType: at,
          bizAppId: bizAppId || (this.magicTag ? this.magicTag.id : ''),
          bizParam,
          chatSessionId: this.screenId,
          askId,
          clientType: this.clientType,
          needIntent
        },
        {
          onmessage: msg => {
            if (this.stopAnswerList[snowId]) return;
            let msgData = JSON.parse(msg.data);
            if ([0, 1, 3, 4, 5, 6, 8].includes(msgData.type)) {
              if (resendType === 'askInternet') {
                let lastMessage = this.msgList[this.msgList.length - 1];
                self.addAnswer({
                  ...lastMessage,
                  contentDetail: {
                    otherSourceAnswer: msgData.contentChip || ''
                  }
                });
              } else {
                // 进行中  3 指令响应数据 4 指令参数缺失需要补齐二次框 5 回显二次框 6 换一换
                self.addAnswer({
                  answerStatus: msgData.answerStatus ? msgData.answerStatus : 1,
                  chatCorrectEnabled: msgData.chatCorrectEnabled || 0, // 是否启用纠错
                  chatLikeFlag: msgData.chatLikeFlag || 0, // 是否评价过
                  chatContentId: msgData.chatContentId, // 消息id
                  askInternet: resendType === 'askInternet' ? 1 : 0,
                  askReqId: snowId,
                  chatType: 1, // 消息类型 1回答 0 提问
                  contentDetail: {
                    content: msgData.contentChip || '',
                    linkList:
                      msgData.linkList && msgData.linkList.length
                        ? msgData.linkList
                        : msg.linkList && msg.linkList.length
                          ? msg.linkList
                          : []
                  },
                  type: msgData.type,
                  bizAppId: msgData.bizAppId,
                  askId: msgData.askId,
                  bizParam: msgData.bizParam,
                  bizModuleCode: msgData.bizModuleCode,
                  bizAppName: msgData.bizAppName || ''
                });
              }

              if (msgData.type !== 0) {
                self.isWaitAnswer = false;
                if (msgData.type === 1) {
                  self.getQueryAskHistory({
                    answer:
                      self.msgList[self.msgList.length - 1].contentDetail.content,
                    ask:
                      self.msgList[self.msgList.length - 2].contentDetail.content
                  });
                }
                if ((!self.screenId || msgData.askTime) && resendType !== 'askInternet') {
                  self.$nextTick(() => {
                    this.$root.$emit('UPDATE_CHAT_TIME', {
                      chatSessionId: self.screenId,
                      time: timestampToTime(msgData.askTime)
                    });
                  });
                }
              }

            } else if (msgData.type === 2) {
              if (self.stopAnswerList[snowId]) return;
              self.isWaitAnswer = false;
              if (msgData.errorMsg) {
                self.addAnswer({
                  type: msgData.type,
                  answerStatus: ANSWER_STATUS.FAIL, // 错误消息
                  askReqId: snowId,
                  chatType: CHAT_TYPE.ANSWER, // 消息类型 1回答 0 提问
                  contentDetail: {
                    content: msgData.errorMsg || '',
                    linkList: []
                  }
                });
              }
            }

            self.$nextTick(() => {
              self.scrollToEnd();
            });
          },
          onclose(msg) {
            if (self.stopAnswerList[snowId]) return;
            if (msg === 'timeout') {
              // 超时错误
              self.$message.error(
                self.$t('pc_biz_ai_network_timeout').d('网络超时，请重试！')
              );
              self.msgList.pop(); // 清除等待消息效果
            }
            if (self.isWaitAnswer) {
              self.isWaitAnswer = false;
            }
            self.resendMsg = null; // 清空重新发送数据
            self.$nextTick(() => {
              self.scrollToEnd();
            });
          },
          onerror(err) {
            if (self.isWaitAnswer) {
              self.isWaitAnswer = false;
            }
            self.resendMsg = null; // 清空重新发送数据
            console.log('onerror', err);
          }
        });

    },
    // 提问题
    addAnswer(answer) {
      if (answer) {
        if (this.msgList.length && this.msgList.length > 1) {
          // 有消息记录
          let lastMessage = this.msgList[this.msgList.length - 1]; // 数组最后一项
          if (
            lastMessage.chatType &&
            (lastMessage.chatContentId && lastMessage.chatContentId === answer.chatContentId)
          ) {
            // 如果是回答id相同则表示内容跟新
            let params = {
              ...answer,
              contentDetail: {
                content:
                  (lastMessage.contentDetail.content || '') +
                  (answer.contentDetail.content || ''), // 拼接消息体
                linkList: [...(lastMessage.contentDetail.linkList || []), ...(answer.contentDetail.linkList || [])],
                otherSourceAnswer: (lastMessage.contentDetail.otherSourceAnswer || '') + (answer.contentDetail.otherSourceAnswer || '')
              }
            };
            this.msgList.splice(this.msgList.length - 1, 1, params);
            console.log('更新消息内容', params);
          } else {
            // 创建新回答
            console.log('创建新消息', answer);
            this.msgList.splice(-1, 1, answer);
          }
        } else {
          // 无历史消息
          // 加载答案
          this.msgList.splice(-1, 1, answer);
        }
      } else {
        // 加载等待消息
        this.msgList.push({
          type: MSG_TYPE.TEXT,
          answerStatus: ANSWER_STATUS.PENDING,
          chatType: CHAT_TYPE.ANSWER
        });
      }
      this.scrollToEnd();
    },

    // 获取查询所需的历史记录
    getQueryAskHistory(newlog) {
      if (newlog) {
        if (this.askHistory.length < 3) {
          this.askHistory.push(newlog);
        } else {
          this.askHistory.push(newlog);
          this.askHistory.shift();
        }
      }
    },
    // 添加提问记录
    addQuestion() {
      // 添加提问记录
      this.msgList.push(
        this.resendMsg || {
          chatType: 0,
          contentDetail: {
            content: this.question
          }
        }
      );
      this.askQuestion = this.question;
      // 清空输入框
      this.question = '';
      this.$refs.textarea.height = '52px';
    },
    // 改变全屏尺寸
    changeFullSize() {
      let bFullscreen = !this.bFullscreen;
      this.$emit('fullscreen', bFullscreen);
      this.scrollToEnd();
    },
    // 分享功能
    share(event) {
      this.showShare = !this.showShare;
    },
    // 滑动到指定元素
    scrollTo(p) {
      const scrollElement =
        this.$refs.scrollbar && this.$refs.scrollbar.$el.firstChild;
      scrollElement && scrollElement.scrollTo(0, p);
    },
    // 滑动底部
    scrollToEnd() {
      this.$nextTick(() => {
        this.scrollTo(this.$refs.dialogBody.scrollHeight);
      });
    },
    askTypeChange(type) {
      if (type === this.askType) return;
      this.magicTag = null;
      this.question = '';
      this.askType = type;
      if (this.msgList[this.msgList.length - 1].type === MSG_TYPE.WELCOME) {
        this.msgList.splice(this.msgList.length - 1, 1, this.getWelcomeMsg(false, type));
      } else {
        this.msgList.push(this.getWelcomeMsg(false, type));
      }
    },
    treasureHandler(item) {
      this.handleChangeMagic(item);
    },
    handleFeedback(msg, state) {
      submitQuestionLike({
        chatContentId: msg.chatContentId || msg.chatRecordId,
        likeAnswer: state === 1
      })
        .then(() => {
          msg.chatLikeFlag = state;
          if (state === 2) {
            this.$refs.feedback.toSubmit(msg);
          }
        })
        .catch(err => {
          if (err && err.error && err.error.message) {
            this.$message.error(err.error.message);
          }
        });
    }
  },
  created() {
    // 互联网问答
    this.$root.$on('ASK_INTERNET', this.askInternet);
    this.$root.$on('TREASURE_HANDLE', this.treasureHandler);
    this.$root.$on('ASK_TYPE_CHANGE', this.askTypeChange);
    this.$root.$on('SCROLL_END', this.scrollToEnd);
    this.$root.$on('PROMPT', this.onPrompt);
    this.$root.$on('HANDLE_FEEDBACK', this.handleFeedback);
  },
  mounted() {
    document.body.addEventListener('click', this.handleShareVisible);
  },
  beforeDestroy() {
    this.$root.$off('ASK_INTERNET', this.askInternet);
    this.$root.$off('TREASURE_HANDLE', this.treasureHandler);
    this.$root.$off('ASK_TYPE_CHANGE', this.askTypeChange);
    this.$root.$off('SCROLL_END', this.scrollToEnd);
    this.$root.$off('PROMPT', this.onPrompt);
    this.$root.$off('HANDLE_FEEDBACK', this.handleFeedback);

    document.body.removeEventListener('click', this.handleShareVisible);
    this.commonAskIdHandler && this.commonAskIdHandler.destoryReleaseAsset();
  }
};
</script>
